import { render, staticRenderFns } from "./PhotosUploadLocationSettings.vue?vue&type=template&id=97148b62&scoped=true"
import script from "./PhotosUploadLocationSettings.vue?vue&type=script&lang=js"
export * from "./PhotosUploadLocationSettings.vue?vue&type=script&lang=js"
import style0 from "./PhotosUploadLocationSettings.vue?vue&type=style&index=0&id=97148b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97148b62",
  null
  
)

export default component.exports